import { createContext, useContext } from "react";

export type OperatingFrontContextValue = {
  returnToPicker: () => void;
};

export const OperatingFrontContext = createContext<OperatingFrontContextValue | null>(null);

export function useOperatingFront(): OperatingFrontContextValue | null {
  return useContext(OperatingFrontContext);
}
